import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import type { ValueOf } from 'cpool-utils';

import type { EventBehaviorProps } from '../../utils/EventBehavior';

export const ContextMenuItemVariant = {
    DEFAULT: 'default',
    DESTRUCTIVE: 'destructive',
} as const;

export type ContextMenuItemVariantType = ValueOf<typeof ContextMenuItemVariant>;

export const CONTEXT_MENU_DIRECTION = {
    BOTTOM: 'bottom',
    TOP: 'top',
} as const;

export type ContextMenuDirection = ValueOf<typeof CONTEXT_MENU_DIRECTION>;

export const CONTEXT_MENU_MAX_HEIGHT = 149; // px
export const CONTEXT_MENU_DEFAULT_PANEL_WIDTH = 200; // px

export interface ContextMenuItem {
    id: string;
    label: ReactNode;
    icon?: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    variant?: ContextMenuItemVariantType;
}

export interface ContextMenuProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'>, EventBehaviorProps {
    items: ContextMenuItem[];
    trigger?: ReactNode;
    children?: ReactNode;
    triggerClassName?: string;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    panelClassName?: string;
    panelWidth?: number;
    maxHeight?: number;
    triggerAriaLabel?: string;
}
